import { api } from "lib/api";
import Footer from "shared/Footer";
import Meta from "shared/Meta";
import Nav from "shared/Nav";
import Image from "shared/Image";
import PostCard from "shared/PostCard";

export default function AuthorBySlug({ settings, author, posts }) {
  return (
    <>
      <Meta settings={settings} />
      <Nav settings={settings} />
      <div className="container mx-auto my-8">
        <div className="flex">
          <div className="w-1/4">
            <div className="flex items-center flex-col">
              {author.profile_image && (
                <Image
                  src={
                    author.profile_image.startsWith("//")
                      ? `http://${author.profile_image.substring(2)}`
                      : author.profile_image
                  }
                  width={150}
                  height={150}
                  alt={`${author.name}'s Photo`}
                  className="rounded-full"
                />
              )}
              <h1 className="text-2xl font-semibold">{author.name}</h1>
              <p className="text-gray-500 text-sm mb-4">{author.count.posts} posts published</p>
              <div className="flex items-center text-gray-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <p>{author.location}</p>
              </div>
            </div>
          </div>
          <div className="w-3/4 min-h-[400px]">
            <div className="grid grid-cols-2">
              {posts?.map((post) => (
                <div className="mr-2 mb-4" key={post.id}>
                  <PostCard post={post} key={post.id} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer settings={settings} />
    </>
  );
}

export async function getStaticProps(context) {
  const {
    params: { slug },
  } = context;

  try {
    const settings = await api.getSettings();
    const author = await api.getAuthorBySlug(slug);
    const posts = await api.getPostsByAuthor(slug);
    return {
      props: {
        settings,
        author,
        posts,
      },
    };
  } catch (err) {
    if (err?.response?.data) {
      console.log(err?.response?.data);
      throw new Error(err.message);
    }
  }
  return { props: {} };
}

export async function getStaticPaths() {
  const authors = await api.getAllAuthors();
  const slugs = authors?.map((author) => ({ params: { slug: author.slug } }));

  return {
    paths: slugs,
    fallback: false,
  };
}
